export function getPromoSnippetVisibility(page: number): boolean {
  return page === 1;
}
